import { Injectable } from '@angular/core';
import { GameName } from '@services/lobby.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InfoService {
  private continueGame?: GameName;
  visible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

  constructor() {
  }

  getStatus(name: GameName): { dontShow: boolean } {
    const local = localStorage.getItem(name)
    return local ? JSON.parse(local) : { dontShow: false }
  }

  continue(name: GameName) {
    this.continueGame = name;
  }

  isContinue(name: GameName) {
    const result = this.continueGame === name;
    this.continueGame = undefined;
    return result;
  }
}
